// https://jonsuh.com/hamburgers/
require('./../../../node_modules/hamburgers/dist/hamburgers.min.css')

const menubtn = document.querySelectorAll('.hamburger')
const menu = document.querySelector('.menumovil')
if(menu){
menubtn.forEach(element => {
    element.addEventListener('click', () => {
        if(element.classList.contains('is-active')){
            // menu off
            element.classList.remove("is-active");
            menu.classList.remove('active');
            document.querySelector('body').style.overflow = 'visible'
        } else {
            //menu on
            element.classList.add("is-active");
            menu.classList.add('active');
            document.querySelector('body').style.overflow = 'hidden'
            
        }
    })
});
}

